export default "__VITE_ASSET__C2SCg6C3__"